export default {
  app: 'APP_RECOVER',
  api: 'http://localhost:8080/portal'
};
